module.exports = __webpack_public_path__ + "static/media/ico_generic_doorkey.b30f1607.svg";